import './_styles.scss';
import React from 'react';
import { Navigation } from 'components';
import { FiLoader } from 'react-icons/fi';

export default function index() {
  return (
    <div className='Details-Placeholder'>

      <Navigation/>

      <div className="section-wrapper">

        <div className="section-header">
          <div className="images">
            <div className="image-list"/>
            <div className="image-active">
              <FiLoader className='loader'/>
            </div>
          </div>
          <div className="metadata">
            <div className="data 01"/>
            <div className="data 02"/>
            <div className="data 03"/>
            <div className="data 04"/>
            <div className="data 05"/>
            <div className="data 06"/>
            <div className="data 07"/>
            <div className="data 08"/>
            <div className="data 09"/>
            <div className="data 10"/>
            <div className="data 11"/>
            <div className="data 12"/>
          </div>
        </div>

        <div className="other-details"/>

      </div>

    </div>
  )
}
